<div class="modal-overlay fixed inset-0 w-full min-h-full flex items-start md:items-center justify-center p-3 md:p-8 z-[1000] overflow-y-auto" id="modal">
    <div class="modal__window relative bg-white border border-[#e8edf3] rounded-2xl shadow-[0_24px_60px_rgba(40,56,66,0.30),0_8px_24px_rgba(40,56,66,0.18)] w-full max-w-[900px] max-h-[92vh] overflow-hidden flex flex-col animation-[modalIn_0.25s_ease-out]" cdkDrag>

        <div id="content-height" class="flex flex-col flex-1 overflow-hidden">

            <section cdkDragHandle class="flex items-center justify-between px-5 py-2.5 bg-gradient-to-b from-[#f8fbff] to-white border-b border-[#e8edf3] rounded-t-2xl cursor-move shrink-0">
                <h2 class="text-base font-medium text-corporate-3 m-0 tracking-wide truncate flex-1 mr-3">Evento - {{title || 'Nuevo evento'}}</h2>
                <div class="flex items-center gap-2 shrink-0">
                    <a (click)='closeEvent($event)' class="modal-close-btn inline-flex items-center justify-center w-9 h-9 rounded-full text-[#5a6b7a] bg-transparent border-none cursor-pointer transition-all duration-200 hover:bg-hover-2 hover:text-corporate hover:rotate-90">
                        <lucide-icon name="x" [size]="22"></lucide-icon>
                    </a>
                    <ng-content select="[a]"></ng-content>
                </div>
            </section>

            <div class="modal-body flex-1 overflow-y-auto">

                <section class="px-5 py-3 mb-0">
                    <div class="inline-flex bg-[#f0f4f8] rounded-lg gap-0.5">
                        <button
                            type="button"
                            (click)="changeChkService()"
                            class="px-4 py-1.5 text-[13px] rounded-md cursor-pointer transition-all duration-200 border-none outline-none"
                            [class.bg-corporate]="service"
                            [class.text-white]="service"
                            [class.shadow-sm]="service"
                            [class.bg-transparent]="!service"
                            [class.text-[#5a6b7a]]]="!service"
                            [class.hover:bg-white]="!service"
                        >
                            Serv. G.Auto/Moto
                        </button>
                        <button
                            type="button"
                            (click)="changeChkServiceTBR()"
                            class="px-4 py-1.5 text-[13px] rounded-md cursor-pointer transition-all duration-200 border-none outline-none"
                            [class.bg-corporate]="serviceTBR"
                            [class.text-white]="serviceTBR"
                            [class.shadow-sm]="serviceTBR"
                            [class.bg-transparent]="!serviceTBR"
                            [class.text-[#5a6b7a]]]="!serviceTBR"
                            [class.hover:bg-white]="!serviceTBR"
                        >
                            Serv. TBR
                        </button>
                        <button
                            type="button"
                            (click)="changeChkTask()"
                            class="px-4 py-1.5 text-[13px] rounded-md cursor-pointer transition-all duration-200 border-none outline-none"
                            [class.bg-corporate]="task"
                            [class.text-white]="task"
                            [class.shadow-sm]="task"
                            [class.bg-transparent]="!task"
                            [class.text-[#5a6b7a]]]="!task"
                            [class.hover:bg-white]="!task"
                        >
                            Tarea
                        </button>
                    </div>

                    <div *ngIf="error && error.type=='title'" class="flex items-center gap-2 mt-2 text-error">
                        <lucide-icon name="triangle-alert" [size]="16"></lucide-icon>
                        <span class="text-xs">{{error.message}}</span>
                    </div>
                </section>

                <section *ngIf="!task" class="px-5 py-3 mb-0">
                    <h3 class="text-[15px] font-bold text-corporate m-0 mb-2 tracking-wide flex items-center gap-1.5">
                        <span class="flex items-center justify-center w-[15px] h-[15px] shrink-0">
                            <lucide-icon name="user" [size]="15"></lucide-icon>
                        </span>
                        Datos del cliente
                    </h3>
                    <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3">
                        <div class="flex flex-col">
                            <label class="text-[12px] font-medium text-corporate-3 mb-1 block">Teléfono <span class="text-error font-bold"> *</span></label>
                            <input #phoneInput id="phoneInput" type="tel" class="form-control w-full px-2.5 py-1.5 text-[13px] text-corporate-3 bg-white border border-[#d4dde6] rounded-lg box-border transition-colors duration-200 outline-none focus:border-corporate" [(ngModel)]="customerSel.customer.TELEFONO" (change)="getCustomerByPhone($event)" name="phoneInput" placeholder="Teléfono">
                        </div>

                        <div class="flex flex-col">
                            <label class="text-[12px] font-medium text-corporate-3 mb-1 block">Matrícula/Vehículo</label>
                            <div class="flex items-center gap-1.5">
                                <input *ngIf="(!customerSel.customer.REGISTRATIONS || customerSel.customer.REGISTRATIONS.length==0) || (inputRegistration)" type="text" class="flex-1 min-w-0 px-2.5 py-1.5 text-[13px] text-corporate-3 bg-white border border-[#d4dde6] rounded-lg box-border transition-all duration-200 outline-none focus:border-corporate" name="inputpres" [(ngModel)]="customerSel.customer.REGISTRATION" placeholder="Indique nueva matrícula" (change)="newRegistration()">
                                <select *ngIf="customerSel.customer.REGISTRATIONS && customerSel.customer.REGISTRATIONS.length>0 && !inputRegistration" class="flex-1 min-w-0 px-2.5 py-1.5 text-[13px] text-corporate-3 bg-white border border-[#d4dde6] rounded-lg box-border transition-all duration-200 outline-none focus:border-corporate" [(ngModel)]="registration" (change)="changeRegistration()">
                                    <option *ngFor="let item of customerSel.customer.REGISTRATIONS">{{item}}</option>
                                </select>
                                <button *ngIf="(customerSel.customer.REGISTRATIONS && customerSel.customer.REGISTRATIONS.length>0) && !inputRegistration" class="btn-add-small desktop" (click)="setInputRegistration()">
                                    <span>Añadir</span>
                                </button>
                                <button *ngIf="customerSel.customer.REGISTRATIONS && customerSel.customer.REGISTRATIONS.length>0 && inputRegistration" class="btn-add-small" (click)="setInputRegistration()">
                                    <span>x</span>
                                </button>
                            </div>
                        </div>

                        <div class="flex flex-col">
                            <label class="text-[12px] font-medium text-corporate-3 mb-1 block">Cliente <span class="text-error font-bold"> *</span></label>
                            <div class="flex items-center gap-1.5">
                                <input type="text" class="flex-1 min-w-0 px-2.5 py-1.5 text-[13px] text-corporate-3 bg-white border border-[#d4dde6] rounded-lg box-border transition-all duration-200 outline-none focus:border-corporate" name="inputname" *ngIf="customerSel" [(ngModel)]="customerSel.customer.NOMCLTE" (focus)="backupValue()" (change)="changeName()" placeholder="Nombre del cliente">
                                <button *ngIf="customerSel" class="flex items-center justify-center w-8 h-8 rounded-lg text-[#5a6b7a] border border-[#d4dde6] bg-transparent cursor-pointer transition-all hover:bg-hover-2 hover:border-corporate hover:text-corporate shrink-0" (click)="searchCustomer('name',customerSel.customer.NOMCLTE)">
                                    <lucide-icon name="search" [size]="14"></lucide-icon>
                                </button>
                            </div>
                        </div>

                        <app-input
                            label="Email"
                            type="email"
                            name="inputemail"
                            placeholder="email@ejemplo.com"
                            [(ngModel)]="customerSel.customer.EMAIL"
                        ></app-input>

                        <div class="flex flex-col">
                            <label class="text-[12px] font-medium text-corporate-3 mb-1 block">Presupuesto</label>
                            <div class="flex items-center gap-1.5">
                                <input type="text" class="flex-1 min-w-0 px-2.5 py-1.5 text-[13px] text-corporate-3 bg-[#f4f6f9] border border-[#d4dde6] rounded-lg box-border opacity-70 cursor-not-allowed" name="inputpres" [(ngModel)]="customerSel.customer.budget" (change)="changeBudget()" disabled>
                                <button class="flex items-center justify-center w-8 h-8 rounded-lg text-[#5a6b7a] border border-[#d4dde6] bg-transparent cursor-pointer transition-all hover:bg-hover-2 hover:border-corporate hover:text-corporate shrink-0" (click)="searchBudget(customerSel.customer.budget)">
                                    <lucide-icon name="search" [size]="14"></lucide-icon>
                                </button>
                            </div>
                            <div *ngIf="error && error.message!='' && error.type=='budget'" class="flex items-center gap-2 mt-1.5 text-error">
                                <span class="text-xs">{{error.message}}</span>
                                <button class="flex items-center justify-center w-6 h-6 rounded text-corporate-3 bg-transparent border-none cursor-pointer" (click)="closeMessageError()">
                                    <lucide-icon name="x" [size]="16"></lucide-icon>
                                </button>
                            </div>
                        </div>

                        <app-input
                            label="O.R Fleet"
                            name="inputpres"
                            placeholder="O.R Fleet"
                            [(ngModel)]="customerSel.customer.orFleet"
                            (changeEvent)="changeORFleet()"
                        ></app-input>
                    </div>

                    <div *ngIf="error && (error.type=='phone' || error.type=='customer' || error.type=='registration')" class="flex items-center gap-2 mt-2 text-error">
                        <lucide-icon name="triangle-alert" [size]="16"></lucide-icon>
                        <span class="text-xs">{{error.message}}</span>
                    </div>
                </section>

                <section class="bg-[#f8fbff] px-5 py-3 mb-0">
                    <div class="flex flex-wrap gap-3" id="visual-input-resources">
                        <div *ngIf="service || serviceTBR" class="flex flex-col flex-1 min-w-[340px]">
                            <h3 class="text-[15px] font-bold text-corporate m-0 mb-2 tracking-wide flex items-center gap-1.5">
                                <span class="flex items-center justify-center w-[15px] h-[15px] shrink-0">
                                    <lucide-icon name="wrench" [size]="15"></lucide-icon>
                                </span>
                                Servicios <span class="text-error font-bold"> *</span>
                            </h3>

                            <app-multi-autocomplete
                                *ngIf="servicesNamesArr && service"
                                [optionGroups]="servicesNamesArr | serviceGroups"
                                [excludeKey]="'idService'"
                                placeholder="Buscar servicio..."
                                (selectionChange)="onServicesSelectionChange($event)"
                            ></app-multi-autocomplete>

                            <app-multi-autocomplete
                                *ngIf="servicesNamesTBRArr && serviceTBR && !service"
                                [optionGroups]="servicesNamesTBRArr | serviceGroups"
                                [excludeKey]="'idService'"
                                placeholder="Buscar servicio TBR..."
                                (selectionChange)="onServicesSelectionChange($event)"
                            ></app-multi-autocomplete>

                            <div class="flex flex-col max-w-[200px] mt-2">
                                <app-input
                                    label="Ref. Neumáticos"
                                    placeholder="Ref. Neumáticos"
                                    [(ngModel)]="customerSel.customer.reference"
                                    (changeEvent)="changeReference()"
                                ></app-input>
                            </div>
                        </div>

                        <div *ngIf="task" class="flex flex-col flex-1 min-w-[200px]">
                            <h3 class="text-[15px] font-bold text-corporate m-0 mb-2 tracking-wide flex items-center gap-1.5">
                                <span class="flex items-center justify-center w-[15px] h-[15px] shrink-0">
                                    <lucide-icon name="list-checks" [size]="15"></lucide-icon>
                                </span>
                                Tareas <span class="text-error font-bold"> *</span>
                            </h3>
                            <app-select
                                [optionGroups]="arrExtrasServices | taskGroups"
                                [(ngModel)]="taskSelected.name"
                                (changeEvent)="getTaskId()"
                            ></app-select>
                        </div>
                    </div>

                    <div *ngIf="error && (error.type=='services' || error.type=='task')" class="flex items-center gap-2 mt-2 text-error">
                        <lucide-icon name="triangle-alert" [size]="16"></lucide-icon>
                        <span class="text-xs">{{error.message}}</span>
                    </div>
                </section>

                <section class="px-5 py-3 mb-0">
                    <h3 class="text-[15px] font-bold text-corporate m-0 mb-2 tracking-wide flex items-center gap-1.5">
                        <span class="flex items-center justify-center w-[15px] h-[15px] shrink-0">
                            <lucide-icon name="calendar" [size]="15"></lucide-icon>
                        </span>
                        Fechas
                        <span *ngIf="showTimeChangeAlert" class="ml-2 inline-flex items-center gap-1 px-2 py-0.5 bg-[#cce3f5] text-corporate text-[11px] font-medium rounded-full leading-none">
                            <span class="flex items-center justify-center w-[11px] h-[11px] shrink-0">
                                <lucide-icon name="clock" [size]="11"></lucide-icon>
                            </span>
                            <span>Hora fin actualizada</span>
                        </span>
                        <span *ngIf="showTimeChangeWarning" class="ml-2 inline-flex items-center gap-1 px-2 py-0.5 bg-red-50 text-error text-[11px] font-medium rounded-full border border-red-200 leading-none">
                            <span class="flex items-center justify-center w-[11px] h-[11px] shrink-0">
                                <lucide-icon name="clock" [size]="11"></lucide-icon>
                            </span>
                            <span>Hora de fin actualizada</span>
                            <a (click)="showTimeChangeWarning = false" class="flex items-center justify-center w-[14px] h-[14px] rounded-full hover:bg-red-100 cursor-pointer ml-0.5 shrink-0">
                                <lucide-icon name="x" [size]="10"></lucide-icon>
                            </a>
                        </span>
                    </h3>
                    <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-3">
                        <div class="flex flex-col relative">
                            <label class="text-[12px] font-medium text-corporate-3 mb-1 block">Desde</label>
                            <input id="select-dateFrom" (focus)="setActive(true,false)" class="w-full px-2.5 py-1.5 text-[13px] text-corporate-3 bg-white border border-[#d4dde6] rounded-lg box-border transition-all duration-200 outline-none focus:border-corporate cursor-pointer" placeholder="{{this.dateFrom}}" tabindex="2" readonly>
                            <div *ngIf="isActiveFrom" class="absolute top-full left-0 mt-1 z-50">
                                <app-date-picker (dateSelected)="clickDateSelected($event)" (closeModal)="setCloseModal($event)"></app-date-picker>
                            </div>
                        </div>
                        <div *ngIf="!allDay" class="flex flex-col" (click)="closeAllDatePickers()">
                            <label class="text-[12px] font-medium text-corporate-3 mb-1 block">Hora inicio</label>
                            <app-select
                                [options]="arrHoursFrom | hoursToOptions"
                                [columns]="4"
                                [(ngModel)]="timeFrom"
                                (changeEvent)="setTime(true, false)"
                            ></app-select>
                        </div>
                        <div class="flex flex-col relative">
                            <label class="text-[12px] font-medium text-corporate-3 mb-1 block">Hasta</label>
                            <input [disabled]="repeat" id="select-dateTo" (click)="setActive(false, true)" class="w-full px-2.5 py-1.5 text-[13px] text-corporate-3 bg-white border border-[#d4dde6] rounded-lg box-border transition-all duration-200 outline-none focus:border-corporate disabled:bg-[#f4f6f9] disabled:opacity-70 disabled:cursor-not-allowed cursor-pointer" placeholder="{{this.dateTo}}" tabindex="4" readonly>
                            <div *ngIf="isActiveTo" class="absolute top-full left-0 mt-1 z-50">
                                <app-date-picker (dateSelected)="clickDateSelected($event)" (closeModal)="setCloseModal($event)"></app-date-picker>
                            </div>
                        </div>
                        <div *ngIf="!allDay" class="flex flex-col" (click)="closeAllDatePickers()">
                            <label class="text-[12px] font-medium text-corporate-3 mb-1 block">Hora fin</label>
                            <app-select
                                [options]="arrHours | hoursToOptions"
                                [columns]="4"
                                [(ngModel)]="timeTo"
                                (changeEvent)="setTime(false, true)"
                            ></app-select>
                        </div>
                    </div>

                    <div *ngIf="error && error.type=='date'" class="flex items-center gap-2 mt-2 text-error">
                        <lucide-icon name="triangle-alert" [size]="16"></lucide-icon>
                        <span class="text-xs">{{error.message}}</span>
                    </div>

                    <div class="flex flex-wrap gap-4 mt-2 items-center">
                        <label class="app-checkbox inline-flex items-center gap-2 text-[13px] font-medium text-corporate-3 cursor-pointer mb-0 leading-none">
                            <input type="checkbox" id="all_day" name="all_day" value="0" [checked]="allDay" (change)="setAllDay($event, allDay=!allDay)" class="app-checkbox-input">
                            <span class="app-checkbox-box"></span>
                            <span>Todo el día</span>
                        </label>
                        <label class="app-checkbox inline-flex items-center gap-2 text-[13px] font-medium text-corporate-3 cursor-pointer mb-0 leading-none">
                            <input type="checkbox" id="recurs" name="recurs" value="0" [checked]="repeat" (change)="changeRepeatCheck()" class="app-checkbox-input">
                            <span class="app-checkbox-box"></span>
                            <span>Se repite</span>
                            <div *ngIf="objParams.repeat && repeat" class="ml-2">
                                <a class="text-corporate underline cursor-pointer text-[13px]" (click)="goToRecurrence()">Mostrar</a>
                            </div>
                        </label>
                    </div>

                    <div class="recurrence-wrapper" [class.recurrence-open]="repeat && (objParams.repeat ? show : repeat)" [class.recurrence-closed]="!(repeat && (objParams.repeat ? show : repeat))">
                        <div class="recurrence-inner mt-2">
                            <div class="inline-flex bg-[#f0f4f8] rounded-lg p-0.5 gap-0.5 mb-2">
                                <button type="button" class="px-3 py-1.5 text-[12px] rounded-md cursor-pointer transition-all duration-200 border-none outline-none"
                                    [class.bg-corporate]="type=='daily'" [class.text-white]="type=='daily'" [class.shadow-sm]="type=='daily'"
                                    [class.bg-transparent]="type!='daily'" [class.text-[#5a6b7a]]]="type!='daily'" [class.hover:bg-white]="type!='daily'"
                                    (click)="type='daily'; changeTab({index:0})">Diariamente</button>
                                <button type="button" class="px-3 py-1.5 text-[12px] rounded-md cursor-pointer transition-all duration-200 border-none outline-none"
                                    [class.bg-corporate]="type=='weekly'" [class.text-white]="type=='weekly'" [class.shadow-sm]="type=='weekly'"
                                    [class.bg-transparent]="type!='weekly'" [class.text-[#5a6b7a]]]="type!='weekly'" [class.hover:bg-white]="type!='weekly'"
                                    (click)="type='weekly'; changeTab({index:1})">Semanalmente</button>
                                <button type="button" class="px-3 py-1.5 text-[12px] rounded-md cursor-pointer transition-all duration-200 border-none outline-none"
                                    [class.bg-corporate]="type=='monthly'" [class.text-white]="type=='monthly'" [class.shadow-sm]="type=='monthly'"
                                    [class.bg-transparent]="type!='monthly'" [class.text-[#5a6b7a]]]="type!='monthly'" [class.hover:bg-white]="type!='monthly'"
                                    (click)="type='monthly'; changeTab({index:2})">Mensualmente</button>
                                <button type="button" class="px-3 py-1.5 text-[12px] rounded-md cursor-pointer transition-all duration-200 border-none outline-none"
                                    [class.bg-corporate]="type=='annually'" [class.text-white]="type=='annually'" [class.shadow-sm]="type=='annually'"
                                    [class.bg-transparent]="type!='annually'" [class.text-[#5a6b7a]]]="type!='annually'" [class.hover:bg-white]="type!='annually'"
                                    (click)="type='annually'; changeTab({index:3})">Anualmente</button>
                            </div>

                            <app-recurrence-events [type]="type" [objParamsVar]="objParams" (objParams)="getParams($event)"></app-recurrence-events>
                        </div>
                    </div>
                </section>

                <section class="bg-[#f8fbff] px-5 py-3 mb-0">
                    <h3 class="text-[15px] font-bold text-corporate m-0 mb-2 tracking-wide flex items-center gap-1.5">
                        <span class="flex items-center justify-center w-[15px] h-[15px] shrink-0">
                            <lucide-icon name="calendar-days" [size]="15"></lucide-icon>
                        </span>
                        Calendario <span class="text-error font-bold"> *</span>
                    </h3>
                    <div class="flex flex-wrap gap-3" id="visual-input-resources">
                        <div class="flex flex-col flex-1">
                            <app-multi-autocomplete
                                *ngIf="calendarsNamesArr"
                                [options]="calendarsNamesArr | calendarOptions"
                                [excludeKey]="'idCalendar'"
                                [preselected]="calendarsNamesSelectedArr"
                                placeholder="Buscar calendario..."
                                (selectionChange)="onCalendarsSelectionChange($event)"
                            ></app-multi-autocomplete>
                        </div>
                    </div>

                    <div *ngIf="error && error.type=='calendars'" class="flex items-center gap-2 mt-2 text-error">
                        <lucide-icon name="triangle-alert" [size]="16"></lucide-icon>
                        <span class="text-xs">{{error.message}}</span>
                    </div>
                </section>

                <section class="px-5 py-3 mb-0">
                    <app-input
                        label="Descripción"
                        name="description"
                        id="input3"
                        placeholder="Descripción del evento..."
                        [maxlength]="255"
                        [(ngModel)]="description"
                    ></app-input>
                </section>

                <section *ngIf="extendedProps && extendedProps.idUserCreate" class="modal-section bg-[#f8fbff] rounded-lg p-2 px-3 mb-3">
                    <div *ngIf="extendedProps.idUserCreate" class="text-[12px] text-corporate-3 italic leading-relaxed">
                        Evento creado por <strong class="font-bold">{{extendedProps.idUserCreate.firstName}}</strong> el {{createdDate}} a las {{createdTime}} hrs.
                        <span *ngIf="extendedProps.idUserLastUpdate">Última actualización por {{extendedProps.idUserLastUpdate.firstName}}, el {{updatedDate}} a las {{updatedTime}} hrs</span>
                    </div>
                </section>

            </div>

            <div class="modal-footer flex flex-wrap justify-end gap-2.5 px-5 py-2.5 border-t border-[#e8edf3] bg-[#fafbfc] rounded-b-2xl shrink-0">
                <button *ngIf="this.title" (click)="deleteEvent()" type="submit" class="btn-modal btn-delete">
                    <lucide-icon name="trash-2" [size]="20"></lucide-icon>
                    <span>Eliminar</span>
                </button>
                <button (click)="saveEvent()" type="submit" class="btn-modal btn-save">
                    <lucide-icon name="check" [size]="20"></lucide-icon>
                    <span>Guardar</span>
                </button>
            </div>

        </div>

        <div #messages></div>
        <div #seriesevents></div>
        <div #share></div>
        <div #customer></div>
        <div #budget></div>

    </div>
</div>